let guardInstalled = false;
let fieldSeq = 0;

const IGNORED_INPUT_TYPES = new Set([
  "button",
  "checkbox",
  "color",
  "file",
  "hidden",
  "image",
  "radio",
  "range",
  "reset",
  "submit",
]);

const PRESERVED_AUTOCOMPLETE = new Set([
  "tel",
  "username",
  "current-password",
  "new-password",
  "one-time-code",
]);

function isEditableField(el) {
  if (!el || !el.tagName) return false;
  const tag = el.tagName.toLowerCase();
  if (tag !== "input" && tag !== "textarea") return false;
  const type = (el.getAttribute("type") || "text").toLowerCase();
  return !IGNORED_INPUT_TYPES.has(type);
}

function shouldProtectField(el) {
  if (!isEditableField(el)) return false;
  if (el.getAttribute("data-allow-autofill") === "true") return false;
  const type = (el.getAttribute("type") || "text").toLowerCase();
  if (type === "password") return false;
  const autocomplete = (el.getAttribute("autocomplete") || "").trim();
  return !PRESERVED_AUTOCOMPLETE.has(autocomplete.toLowerCase());
}

function protectField(el) {
  if (!shouldProtectField(el)) return;
  el.setAttribute("autocomplete", "off");
  el.setAttribute("autocorrect", "off");
  el.setAttribute("autocapitalize", "off");
  el.setAttribute("spellcheck", "false");
  if (!el.getAttribute("name")) {
    fieldSeq += 1;
    el.setAttribute("name", `yzai_field_${fieldSeq}`);
  }
}

function protectFields(root) {
  if (!root) return;
  if (isEditableField(root)) {
    protectField(root);
  }
  if (typeof root.querySelectorAll !== "function") return;
  root.querySelectorAll("input, textarea").forEach(protectField);
}

export function installAutocompleteGuard(router) {
  if (guardInstalled || typeof window === "undefined" || typeof document === "undefined") {
    return;
  }
  guardInstalled = true;

  const scheduleProtect = () => {
    window.requestAnimationFrame(() => protectFields(document));
  };

  scheduleProtect();
  document.addEventListener(
    "focusin",
    (event) => {
      protectField(event.target);
    },
    true
  );

  if (typeof MutationObserver !== "undefined") {
    const observer = new MutationObserver(scheduleProtect);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (router && typeof router.afterEach === "function") {
    router.afterEach(() => scheduleProtect());
  }
}
